import { Linkedin, Link2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButtons = ({ label = "Share this", light = false }) => {
  const shareOnLinkedIn = () => {
    const url = encodeURIComponent(window.location.origin);
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      "_blank",
      "noopener,noreferrer,width=600,height=600"
    );
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.origin);
      toast.success("Link copied — paste it anywhere to share.");
    } catch {
      toast.error("Could not copy. The link is " + window.location.origin);
    }
  };

  const base = light
    ? "border-bone/30 text-bone/80 hover:border-bone hover:text-bone"
    : "border-pine/25 text-pine/70 hover:border-forest hover:text-forest";

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="share-buttons">
      <span className={`font-mono text-[10px] uppercase tracking-[0.25em] ${light ? "text-bone/50" : "text-pine/50"}`}>
        {label}
      </span>
      <button
        onClick={shareOnLinkedIn}
        data-testid="share-linkedin-btn"
        className={`inline-flex items-center gap-2 border px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${base}`}
      >
        <Linkedin size={14} /> Share on LinkedIn
      </button>
      <button
        onClick={copyLink}
        data-testid="share-copy-link-btn"
        className={`inline-flex items-center gap-2 border px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${base}`}
      >
        <Link2 size={14} /> Copy link
      </button>
    </div>
  );
};
